import coachImg from "../assets/coach/javed.png";
import { useState } from "react";

const coaches = [
    {
        name: "Mohamed Javid",
        title: "ICC Level 1 Certified Cricket Coach",
        sport: "Cricket",
        emoji: "🏏",
        image: coachImg,
        overview:
            "Experienced Cricket Player & coach with a strong background in playing club & County cricket in various countries like India, U.A.E, Oman & USA. Over 8 years of professional experience in coaching State & District teams, Corporate & community level teams in India and U.A.E.",

        sections: [
            {
                icon: "📍",
                title: "Professional Experience",
                accent: "#00f5a0",
                items: [
                    "State & District Leagues in Tamil Nadu, INDIA",
                    "Elite Division in Emirates Cricket Board, UAE",
                    "Gulf Cooperation Council Tournaments in Oman",
                    "Midwest Premier League in USA",
                ],
            },
            {
                icon: "👥",
                title: "Major Teams Represented",
                accent: "#00d9f5",
                items: [
                    "Germany Bonn Zalmi",
                    "Abu Dhabi XI",
                    "ECB Blues",
                    "AL Gurg CC",
                    "IGM UAE",
                    "Spic Recreation Club Cricket Team",
                    "Midwest Stars USA",
                ],
            },
            {
                icon: "💼",
                title: "Coaching Experience",
                accent: "#a78bfa",
                items: [
                    "King Star Cricket Academy (KSCA), INDIA",
                    "Desert Cricket Cubs (DCC), UAE",
                    "Chicago Youth Cricket Academy (CYCA), USA",
                ],
            },
        ],
    },
];

function CoachCard({ coach }) {
    const [flipped, setFlipped] = useState(false);

    return (
        <div
            style={styles.cardWrapper}
            onMouseEnter={() => setFlipped(true)}
            onMouseLeave={() => setFlipped(false)}
        >
            {/* Glow effect */}
            <div style={styles.glow} />

            <div
                style={{
                    ...styles.cardInner,
                    transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
            >
                {/* FRONT */}
                <div style={styles.cardFront}>
                    <img src={coach.image} alt={coach.name} style={styles.image} />

                    <div style={styles.content}>
                        <h3 style={styles.name}>
                            {coach.emoji} {coach.name}
                        </h3>

                        <p style={styles.role}>{coach.title}</p>

                        <p style={styles.hint}>Hover to learn more →</p>
                    </div>
                </div>

                {/* BACK */}
                <div style={styles.cardBack}>
                    <h3 style={styles.name}>{coach.name}</h3>
                    <p style={styles.role}>{coach.title}</p>

                    {/* SCROLLABLE CONTENT */}
                    <div style={styles.scrollArea}>
                        <div style={styles.overviewBox}>
                            <p style={styles.overview}>{coach.overview}</p>
                        </div>

                        <div style={styles.sections}>
                            {coach.sections.map((sec) => (
                                <div key={sec.title}>
                                    <div style={styles.sectionHeader}>
                                        <span style={{ color: sec.accent }}>{sec.icon}</span>
                                        <span style={styles.sectionTitle}>{sec.title}</span>
                                    </div>

                                    <ul style={styles.list}>
                                        {sec.items.map((item) => (
                                            <li key={item} style={styles.listItem}>
                                                <span
                                                    style={{
                                                        ...styles.dot,
                                                        backgroundColor: sec.accent,
                                                    }}
                                                />
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function CoachesPage() {
    return (
        <div style={styles.page}>

            {/* HERO */}
            <section style={styles.hero}>
                <span style={styles.badge}>MEET THE TEAM</span>

                <h1 style={styles.title}>
                    Our <span style={styles.gradientText}>Coaches</span>
                </h1>

                <p style={styles.subtitle}>
                    Dedicated professionals committed to improving your game and helping
                    you grow as an athlete.
                </p>
            </section>

            {/* COACH GRID */}
            <section>
                <div style={styles.grid}>
                    {coaches.map((coach) => (
                        <CoachCard key={coach.name} coach={coach} />
                    ))}
                </div>
            </section>
        </div>
    );
}

const styles = {
    page: {
        width: "100%",
        boxSizing: "border-box",   
        overflowX: "hidden",       
        padding: "20px",
        color: "#fff",
    },

    /* HERO */
    hero: {
        textAlign: "center",
        padding: "15px 15px",
    },

    badge: {
        display: "inline-block",
        padding: "6px 14px",
        borderRadius: "20px",
        background: "rgba(0,255,150,0.1)",
        border: "1px solid rgba(0,255,150,0.3)",
        color: "#00f5a0",
        fontSize: "12px",
        letterSpacing: "1px",
        marginBottom: "10px",
    },

    title: {
        fontSize: "42px",
        marginBottom: "10px",
    },

    gradientText: {
        background: "linear-gradient(90deg, #00f5a0, #00d9f5)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },

    subtitle: {
        color: "#d1d5db",
        fontSize: "16px",
    },

    /* GRID */
    grid: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "30px",
        marginTop: "20px",
    },

    /* CARD */
    cardWrapper: {
        width: "300px",
        height: "420px",
        perspective: "1000px",
        position: "relative",
    },

    glow: {
        position: "absolute",
        inset: "0",
        borderRadius: "20px",
        background:
            "linear-gradient(135deg, rgba(0,245,160,0.2), rgba(0,217,245,0.15))",
        filter: "blur(20px)",
        opacity: 0.6,
        transition: "0.3s",
    },

    cardInner: {
        position: "relative",
        width: "100%",
        height: "100%",
        transformStyle: "preserve-3d",
        transition: "transform 0.6s ease",
    },

    cardFront: {
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        background: "rgba(0,40,70,0.7)",
        borderRadius: "20px",
        overflow: "hidden",
        border: "1px solid rgba(0,255,150,0.2)",
        display: "flex",
        flexDirection: "column",
    },

    cardBack: {
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
        background: "rgba(0,40,70,0.85)",
        borderRadius: "20px",
        border: "1px solid rgba(0,255,150,0.3)",

        padding: "20px",

        display: "flex",
        flexDirection: "column",

        overflow: "hidden", // ✅ IMPORTANT (prevents bleed outside)
    },

    image: {
        width: "100%",
        height: "220px",
        objectFit: "cover",
        objectPosition: "top",
    },

    content: {
        padding: "20px",
    },

    name: {
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "5px",
    },

    role: {
        fontSize: "14px",
        color: "#00d9f5",
        marginBottom: "10px",
    },

    overview: {
        fontSize: "14px",
        color: "#d1d5db",
        lineHeight: "1.5",
    },

    hint: {
        fontSize: "12px",
        color: "#aaa",
        marginTop: "10px",
    },

    overviewBox: {
        marginTop: "10px",
        padding: "10px",
        borderRadius: "10px",
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.1)",
    },

    sections: {
        marginTop: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },

    sectionHeader: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        marginBottom: "4px",
    },

    sectionTitle: {
        fontSize: "13px",
        fontWeight: "bold",
    },

    list: {
        paddingLeft: "16px",
        margin: 0,
    },

    listItem: {
        display: "flex",
        alignItems: "flex-start",
        gap: "6px",
        fontSize: "12px",
        color: "#ccc",
        marginBottom: "3px",
    },

    dot: {
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        marginTop: "6px",
        flexShrink: 0,
    },

    scrollArea: {
        marginTop: "10px",
        overflowY: "auto",
        paddingRight: "6px",
        flex: 1,

        scrollbarWidth: "thin",
    },
};

export default CoachesPage;